import axios from "axios";

export interface IFSCResponse {
  MICR: string;
  BRANCH: string;
  ADDRESS: string;
  STATE: string;
  CONTACT: string;
  UPI: boolean;
  RTGS: boolean;
  CITY: string;
  CENTRE: string;
  DISTRICT: string;
  NEFT: boolean;
  IMPS: boolean;
  SWIFT: string | null;
  ISO3166: string;
  BANK: string;
  BANKCODE: string;
  IFSC: string;
}

export class BankService {
  private static BASE_URL = "https://ifsc.razorpay.com";

  /**
   * Get bank details for a given IFSC code
   * @param ifsc 11-character IFSC code
   * @returns Bank details or null if failed
   */
  static async getBankDetails(ifsc: string): Promise<IFSCResponse | null> {
    if (!ifsc || ifsc.length !== 11) {
      return null;
    }

    try {
      const response = await axios.get<IFSCResponse>(
        `${this.BASE_URL}/${ifsc.toUpperCase()}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching bank details:", error);
      return null;
    }
  }
}
